import { addDoc, collection, doc, getDoc, updateDoc,  } from "firebase/firestore";
import { firebaseDB } from "../../firebase";
import { UserProfile } from "../../types/budgethelper";
import { Timestamp } from "firebase/firestore";

export const useCreateBudgetGroup = () => {
	const budgetGroupCollectionRef = collection(firebaseDB, "budgetGroups");

	const createBudgetGroup = async (budgetGroupName: string, currentUser: UserProfile) => {
		const budgetGroup = {
				friendlyName: budgetGroupName,
				createdAt: Timestamp.now(),
				userIds: [currentUser.userId],
				createdBy: currentUser.userId
			};
		
		const budgetGroupDoc = await addDoc(budgetGroupCollectionRef, budgetGroup);

		const userRef = doc(firebaseDB, "users", currentUser.userId);
		const userSnap = await getDoc(userRef);
		if (userSnap.exists()) {
			const userData = userSnap.data();
			const budgetGroups = userData.budgetGroups as string[];
			budgetGroups.push(budgetGroupDoc.id);
			await updateDoc(userRef, {
				budgetGroups
			});
		};
	};

	return { createBudgetGroup };
};